import React from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { templateActions } from "../../templateStore";
import BannerImages from "../../Common/BannerImages";
import LanguageTable from "../../Common/LanguageTable";
import ConnectiviteDivers from "../../Common/ConnectiviteDivers";
import { templateDefaultValue } from "@constants/template";
import Preview from "../../Application/ShopInformationPage/Preview";
import { useSelector } from "react-redux";

function ApplicationShopInformationPage({ selectedRows }: any) {
    const { t } = useTranslation();
    const [isReady, setIsReady] = React.useState(false);

    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );
    const [activeTab, setActiveTab] = React.useState<number>(0);
    let schema: any = useSelector(
        (state: any) => state.global.entityDetails.franchise_schema
    );
    const boutique = schema + "_" + selectedRows[0].shopId;

    const detailsImagePath = React.useMemo(
        () => ["Application", "ChoixBoutique", boutique, "ImageDetails"],
        [boutique]
    );
    function toggleNav(tab: number) {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    }
    React.useEffect(() => {
        const ensureAllPaths = async () => {
            await templateActions.ensurePathExists(
                ["Application", "ChoixBoutique", boutique, "ImageDetails"],
                { Url: "", Name: "", Type: "", Extenxion: "" }
            );

            await templateActions.ensurePathExists(
                ["Application", "ChoixBoutique", boutique, "Description"],
                templateDefaultValue.Application.ChoixBoutique.Default
                    .Description
            );

            await templateActions.ensurePathExists(
                ["Application", "ChoixBoutique", boutique, "SocialMedia"],
                {
                    TikTok: {
                        Url: "",
                        Activer: false,
                    },
                    Youtube: {
                        Url: "",
                        Activer: false,
                    },
                    Facebook: {
                        Url: "",
                        Activer: false,
                    },
                    Snapchat: {
                        Url: "",
                        Activer: false,
                    },
                    Instagram: {
                        Url: "",
                        Activer: false,
                    },
                }
            );

            setIsReady(true);
        };

        ensureAllPaths();
    }, [boutique]);

    if (!isReady) return null;

    const tabs = [
        {
            title: t("Shop information"),
            content: (
                <div className="banner-container">
                    <section className="text-section">
                        <div className="banner-images">
                            <BannerImages
                                dataPath={detailsImagePath}
                                title="Image shop"
                                size="(png,jpg,jpeg ou webp)"
                            />
                        </div>
                        <LanguageTable
                            path={["Application", "ChoixBoutique", boutique]}
                            fields={[
                                {
                                    key: "Description",
                                    label: "Description",
                                    placeholder: "Enter the description",
                                },
                            ]}
                            defaultTexts={
                                templateDefaultValue.Application.ChoixBoutique
                                    .Default
                            }
                            sectionTitle="Description boutique"
                        />
                        <ConnectiviteDivers
                            path={[
                                "template",
                                "Application",
                                "ChoixBoutique",
                                boutique,
                                "SocialMedia",
                            ]}
                        />
                    </section>
                </div>
            ),
            customClassName: "",
        },
    ];
    return (
        <div className="d-flex justify-content-between">
            <div style={{ width: "65% " }}>
                <div style={{ borderBottom: "1px solid #ddd4d4" }}>
                    <Nav
                        tabs
                        style={{
                            backgroundColor: "white",
                            width: "50px",
                            display: "grid",
                            gridTemplateColumns: `repeat(${tabs.length}, 1fr)`,
                            border: "unset",
                        }}
                    >
                        {tabs.map((element, index) => (
                            <NavItem
                                key={index}
                                className={classNames(
                                    "pb-1",
                                    "d-flex align-items-center text-nowrap",
                                    {
                                        "disable-nav-item__clz":
                                            activeTab !== index,
                                    },
                                    element.customClassName
                                )}
                                style={{
                                    cursor: "pointer",
                                    borderBottom:
                                        activeTab === index
                                            ? `${mainColor} 3px solid`
                                            : "",
                                }}
                            >
                                <NavLink
                                    className={classNames("text-dark w-100", {
                                        "active customer-account-menu-nav-link-active__clz":
                                            activeTab === index,
                                        "customer-account-menu-nav-link-disable__clz":
                                            activeTab !== index,
                                    })}
                                    onClick={() => toggleNav(index)}
                                >
                                    <span
                                        className="px-2"
                                        style={{
                                            font:
                                                "normal normal 600 20px/27px Segoe UI",
                                            marginRight: "20px",
                                        }}
                                    >
                                        {element.title}
                                    </span>
                                </NavLink>
                            </NavItem>
                        ))}
                    </Nav>
                </div>
                <TabContent activeTab={activeTab} className="h-100">
                    {tabs.map((element, index) => (
                        <TabPane
                            tabId={index}
                            key={index}
                            style={{ height: "90%" }}
                        >
                            {element.content}
                        </TabPane>
                    ))}
                </TabContent>
            </div>
            <div style={{ width: "35%" }}>
                <Preview
                    shopData={{
                        shopName: selectedRows[0].Boutique,
                        shopAdress: selectedRows[0].Adresse,
                        boutique: boutique,
                    }}
                />
            </div>
        </div>
    );
}

export default ApplicationShopInformationPage;
